import { render, staticRenderFns } from "./lazyblock_us_chefs.vue?vue&type=template&id=9d39be82&scoped=true"
import script from "./lazyblock_us_chefs.vue?vue&type=script&lang=js"
export * from "./lazyblock_us_chefs.vue?vue&type=script&lang=js"
import style0 from "./lazyblock_us_chefs.vue?vue&type=style&index=0&id=9d39be82&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d39be82",
  null
  
)

export default component.exports